import type { ReactNode } from "react";
import { faDigits } from "../i18n/digits";
import { fa } from "../i18n/fa";

/* ------------------------------------------------------------------ *
 * شلم's MOMENTS ON THE FELT (P1 Task 6) — what the felt says as a trick ends: the «+۱۰» on a
 * collected trick (`TrickPointsChip`, P2-1), the point cards the winner's team just took, at the
 * diamond's centre from the collect's start. The table decides WHEN (`game/shelem-moments.ts`).
 * The felt-wide banner for all twelve tricks (a sweep, a «شلم» call made — P1-8) lived here until
 * P1 Task 7, which folded it into the hand-end card's result line (`shelem-hand-end.tsx`): on the
 * 320 px felt under a 130 % zoom the card and a banner at the felt's foot cannot both fit.
 * ------------------------------------------------------------------ */

/**
 * «+۱۰» ON THE TRICK as it is collected (P2-1): the card points (A/10 = 10, 5 = 5) the winner's team
 * just took — once per trick, never before its collect (the sweep is what names the taker), in that
 * team's colour (yours green, theirs red — the HUD's). At the diamond's centre, ABOVE the trick's
 * layer but never IN it (fix 1 — review I-2: riding the collect's fading layer it was ≥ 0.5 opaque for
 * ~75 ms): the cards sweep away from under it and it stays, at full opacity, for `TRICK_POINTS_MS`
 * (`game/shelem-moments.ts`). Decorative — the HUD says the numbers (`aria-hidden`).
 */
export function TrickPointsChip({
  points,
  mine,
  top,
}: {
  points: number;
  /** The trick went to your team. */
  mine: boolean;
  /** The diamond's centre, felt-relative (`calc(50% + drop)`). */
  top: string;
}): ReactNode {
  // the outer span is centred on the point (its translate); the inner one pops — `pop-in-glow`
  // animates `transform`, which would otherwise drop the centring for its 350 ms
  return (
    <span
      aria-hidden="true"
      className="pointer-events-none absolute z-10 -translate-x-1/2 -translate-y-1/2"
      style={{ left: "50%", top }}
    >
      <span
        data-testid="shelem-trick-points"
        data-team={mine ? "us" : "them"}
        dir="ltr"
        className={`block whitespace-nowrap rounded-full bg-surface-container-highest px-2 py-0.5 text-[12px] font-extrabold leading-none shadow-md ${
          mine ? "text-primary" : "text-error"
        }`}
        style={{ animation: "pop-in-glow .35s ease" }}
      >
        {fa.shelem.plusPoints(faDigits(points))}
      </span>
    </span>
  );
}
